class CartTool extends HTMLElement {
  constructor() {
    super();

    const buttons = this.querySelectorAll('.cartTool-item');

    buttons.forEach((button) => {
      button.addEventListener('click', (event) => {
        const trigger = event.currentTarget || event.target.closest('.cartTool-item');
        const id = trigger?.dataset?.popup;
        const popup = id ? document.getElementById(id) : null;

        if (!popup) return;

        const openedPopup = document.querySelector('.popup-toolDown.show');

        if (openedPopup && openedPopup !== popup) {
          openedPopup.classList.remove('show');
        }

        popup.classList.add('show');
        document.querySelector('.previewCart')?.classList.add('active-tool');
      });
    });
  }
}

if (!customElements.get('cart-item-tool')) {
  customElements.define('cart-item-tool', CartTool);
}

class CartCancel extends HTMLElement {
  constructor() {
    super();

    this.querySelector('button')?.addEventListener('click', () => {
      document.querySelector('.popup-toolDown.show')?.classList.remove('show');
      document.querySelector('.previewCart')?.classList.remove('active-tool');
    });
  }
}

if (!customElements.get('cart-cancel-popup')) {
  customElements.define('cart-cancel-popup', CartCancel);
}

class CartNote extends HTMLElement {
  constructor() {
    super();

    this.querySelector('[data-update-note]')?.addEventListener('click', () => {
      this.val = this.querySelector('.text-area')?.value || '';
      const body = JSON.stringify({ note: this.val });

      fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body } });

      document.querySelector('.popup-toolDown.show')?.classList.remove('show');
      document.querySelector('.previewCart')?.classList.remove('active-tool');
    });
  }
}

if (!customElements.get('cart-note')) {
  customElements.define('cart-note', CartNote);
}

class CouponCode extends HTMLElement {
  constructor() {
    super();

    if (localStorage.getItem('storedDiscount') && this.querySelector('input[name="discount"]')) {
      this.querySelector('input[name="discount"]').value = localStorage.getItem('storedDiscount');
    }

    this.querySelector('[data-update-coupon]')?.addEventListener('click', () => {
      this.val = this.querySelector('input[name="discount"]')?.value || '';

      localStorage.setItem('storedDiscount', this.val);

      fetch(`/discount/${this.val}`).then((response) => response.text());

      document.querySelector('.popup-toolDown.show')?.classList.remove('show');
      document.querySelector('.previewCart')?.classList.remove('active-tool');
      Shopify.getCart((cart) => {
        window.sharedFunctions?.updateSidebarCart(cart);
      });
    });
  }
}

if (!customElements.get('coupon-code')) {
  customElements.define('coupon-code', CouponCode);
}
